import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useDispatch } from 'react-redux';

import { updateUiState } from 'redux/slices/uiSlice';

function CircularCountdown({ n = 5 }) {
  const [timeLeft, setTimeLeft] = useState(n);
  const dispatch = useDispatch();

  useEffect(() => {
    if (timeLeft === 0) {
      dispatch(
        updateUiState({
          key: 'showUndoSendTimer',
          value: null,
        }),
      );
    }
  }, [timeLeft]);

  useEffect(() => {
    if (timeLeft === 0) return;

    const timerId = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerId);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft]);

  if (timeLeft === 0) return null;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={(timeLeft / n) * 100}
        size={24}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {timeLeft}
        </Typography>
      </Box>
    </Box>
  );
}

CircularCountdown.propTypes = {
  n: PropTypes.number,
};

export default CircularCountdown;
